// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Lpa-z","fadeIn":"Mpa-z","delay":"Npa-z","recommendedSizeTooltip":"Opa-z"};